import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface RoadBlock{
  link: string,
  imagePath: string
}

@Component({
  selector: 'app-road-block',
  templateUrl: './road-block.component.html',
  styleUrls: ['./road-block.component.css']
})
export class RoadBlockComponent{

  constructor(public dialogRef: MatDialogRef<RoadBlockComponent>, @Inject(MAT_DIALOG_DATA) public data: RoadBlock) {
   
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
